"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.success = exports.error = exports.pending = void 0;
var types_1 = require("../types");
var pending = function (p) { return ({
    status: types_1.promiseState.pending,
    value: p
}); };
exports.pending = pending;
var error = function (e) { return ({
    status: types_1.promiseState.error,
    value: e
}); };
exports.error = error;
var success = function (s) { return ({
    status: types_1.promiseState.success,
    value: s
}); };
exports.success = success;
